import { Component, Input, Output, EventEmitter, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
	standalone: false,
	selector: 'qe-slide-toggle',
	templateUrl: './slide-toggle.component.html',
	styleUrls: ['./slide-toggle.component.scss'],
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => SlideToggleComponent),
			multi: true
		}
	]
})
export class SlideToggleComponent implements ControlValueAccessor {
	@Input() checked: boolean = false;
	@Input() disabled: boolean | null = false;
	@Input() ariaLabel?: string;
	@Input() ariaLabelledby?: string;
	@Output() toggleChange = new EventEmitter<{ checked: boolean }>();

	public toggle(): void {
		if (this.disabled) return;

		this.checked = !this.checked;
		this.onChange(this.checked);
		this.onTouched();
		this.toggleChange.emit({ checked: this.checked });
	}

	// ControlValueAccessor implementation
	public writeValue(value: boolean): void {
		this.checked = !!value;
	}

	public registerOnChange(fn: (value: boolean) => void): void {
		this.onChange = fn;
	}

	public registerOnTouched(fn: () => void): void {
		this.onTouched = fn;
	}

	public setDisabledState(isDisabled: boolean): void {
		this.disabled = isDisabled;
	}

	private onChange = (_value: boolean) => {};
	private onTouched = () => {};
}
